module.exports = __webpack_public_path__ + "static/media/IconAccessible.c55fbacc.png";